import { ReactNode, Children } from 'react';

import styles from './BlockGrid.module.scss';

export type Props = {
  children: ReactNode;
  /**
   * Set a max number of columns for rendered on a row
   */
  maxColumns?: number;
  /**
   * max-width in pixels applied to the content area of container.
   */
  maxWidth?: number;
};

export const BlockGrid = ({ children, maxColumns, maxWidth = 1170 }: Props) => {
  const childrenLength = maxColumns || Children.toArray(children).length;

  return (
    <div
      className={styles.root}
      data-zds
      style={{
        '--_zds-block-grid-max-width': maxWidth,
        // BlockGrid requires 3 different grid layouts for different breakpoints.
        '--_zds-block-grid-grid-template-columns-small': 'repeat(1, 1fr)',
        '--_zds-block-grid-grid-template-columns-medium': `repeat(${childrenLength === 2 || maxColumns === 2 ? 2 : 1}, 1fr)`,
        '--_zds-block-grid-grid-template-columns-large': `repeat(${childrenLength}, 1fr)`,
      }}
    >
      {children}
    </div>
  );
};
